export default function getAuthHeader() {
  const jwt = localStorage.getItem("token");
  if (jwt) {
    return { Authorization: "Bearer " + jwt };
  } else {
    return {};
  }
}
